// Meta (Facebook) Pixel in the browser — the base code and PageView are in public/index.html.
// CompleteRegistration also goes out server-side (api lib/fbAds.js sendRegistrationEvent) with
// event_id 'reg_<account id>'; the browser sends the same id so Meta counts the signup once,
// and the browser event carries the _fbp/_fbc cookies that tie it to the ad click.

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
  }
}

// Fires only for an account created in the last 10 minutes (Google sign-in reuses the same
// path for returning customers).
export function trackRegistration(user: {_id?: string; created_at?: string} | null | undefined) {
  try {
    if (!user || !user._id || !window.fbq) return
    const created = user.created_at ? new Date(user.created_at).getTime() : 0
    if (!created || Date.now() - created > 10 * 60 * 1000) return
    window.fbq('track', 'CompleteRegistration', {status: 'trial'}, {eventID: 'reg_' + user._id})
  } catch (_) {}
}
